import {Component, Input, OnInit} from '@angular/core';
import {TrabalhoComponent} from "../trabalho/trabalho.component";
import {CategoriaCientificaService} from "../categoria_cientifica/categoria_cientifica.service";
import {CadastroService} from "../cadastro/cadastro.service";
import {AcessoService} from "../acesso/acesso.service";
import {TrabalhoService} from "../trabalho/trabalho.service";
import {InscricaoService} from "../inscricao/inscricao.service";
import {CategoriaCientifica} from "../categoria_cientifica/categoria_cientifica";
import {TrabalhoDetailComponent} from "../trabalho-detail/trabalho-detail.component";
import {Inscricao} from "../inscricao/inscricao";
declare var jQuery:any;

@Component({
    selector: 'app-trabalho-edit',
    templateUrl: './trabalho-edit.component.html',
    styleUrls: ['./trabalho-edit.component.css'],
    providers: [
        CategoriaCientificaService,
        TrabalhoService,
        AcessoService,
        InscricaoService,
        CadastroService
    ]
})
export class TrabalhoEditComponent extends TrabalhoDetailComponent implements OnInit {

    @Input('trab_id')trabalho_id:number;
    carregado:boolean;

    ngOnInit() {
		if (!this.islogged()) {
            this.router.navigateByUrl('acesso');
        } else {
			this.carregado=false;
			this.categoriaCientificaService.get()
				.then(categorias => this.categorias = categorias);
			this.unidades_executoras = this.trabalhoService.unidades_executoras;
			this.route.params.subscribe(params => this.trabalho_id = +params['id']);
			this.trabalhoService.getTrabalho(this.trabalho_id).then(trabalho => {this.gettrab(trabalho); 
							     this.inscricaoService.getInscricao(trabalho.inscricao_id).then(inscricao => this.setInscricao(inscricao));
								 this.trabalhoService.getEtapas(this.trabalho_id).then(etapas => this.setEtapas(this.trabalho, etapas));});
			
			this.max_palavras_resumo = 250;
			this.palavras_resumo_restantes = this.max_palavras_resumo;
			this.editAdmin = this.isAdmin();
		}
	}

    gettrab(dados){
        this.trabalho=dados;
		this.trabalho.datas_ini = [null];
		this.trabalho.datas_fim = [null];
    }
	
	setInscricao(inscricao: Inscricao): void {
		if (inscricao.usuario_id != this.user_id && !this.isAdmin())
			this.router.navigateByUrl('inicio');
		else
			this.inscricao = inscricao;
	}

    onSubmit() {
		if (this.trabalho.enviado == null)
			this.trabalho.enviado = false;
		if (this.trabalho.enviado && !this.trabalho.parecer) {
			this.trabalho.enviado = false;
			this.utils.exibirMensagem('Ao enviar em definitivo é preciso anexar o PDF.', 'warning');
        } else {
			let erro: string = this.trabalhoService.validarDatas(this.trabalho);
			if (erro)
				this.utils.exibirMensagem(erro, 'warning');
			else {
				this.spinnerService.show();
				this.trabalhoService.salvar(this.trabalho, true).then(response => {
					if (!this.trabalho.enviado)
						this.utils.exibirMensagem('Proposta salva com sucesso! ATENÇÃO, ALUNO RESPONSÁVEL! O evento proposto foi APENAS SALVO; para finalizar é necessário apertar o botão ENVIAR!', 'success');
					else if (!this.editAdmin)
						this.utils.exibirMensagem('Proposta enviada em DEFINITIVO com sucesso!', 'success');
					else 
						this.utils.exibirMensagem('Proposta editada com sucesso!', 'success');
					this.spinnerService.hide();
					this.goBack();
				});
			}
		}
    }

	upload(event: any):void{
      let parecer: FileList = event.target.files;
      let arquivo: File = parecer[0];
      this.trabalho.parecer = arquivo;
    }

}



// WEBPACK FOOTER //
// ./src/app/trabalho-edit/trabalho-edit.component.ts